import React from "react";
import Api from "../../../../services/ServiceApi";
import { Collapse, Table } from "antd";
// import moment from "moment";
import { FormatDateTime } from "../../../utility/format";

import ProgressDynamic from "../../../dynamic_label/dynamic_label_group";
import { isMobile } from "react-device-detect";
const { Panel } = Collapse;

export default function Progress({
  title,
  Jobdata,
  litemode,
  locale,
  language,
  factupdate,
}) {
  const { result_job_log, result_total_time, result_assignment } = Jobdata;
  const TeamName = result_assignment.filter((data) => {
    return data.subflag === "O";
  });
  const columns = [
    {
      title: "Employee Name",
      dataIndex: "emp_name",
      key: "emp_name",
      width: 230,
    },
    {
      title: "Process Name",
      dataIndex: "",
      key: "",
      width: 330,
      render: (item) => {
        if (item.data_dynamic === null || item.data_dynamic === "{}") {
          return <span>{item.process_name}</span>;
        } else {
          return (
            <div>
              <span>{item.process_name}</span>
              <ProgressDynamic
                wrapClassname={`progress-log`}
                factupdate={factupdate}
                locale={locale}
                language={language}
                data={item.data_dynamic}
                groupHeader={false}
              ></ProgressDynamic>
            </div>
          );
        }
      },
    },
    {
      title: "Date/Time",
      dataIndex: "creatE_DATE",
      key: "creatE_DATE",
      width: 140,
      render: (text) => <FormatDateTime text={text}></FormatDateTime>,
    },
  ];
  return (
    <>
      <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
        <Panel
          header={
            <>
              <img
                src={Api.absoluteUrl(`/icon/progress.svg`)}
                alt={title}
                title={title}
              />
              <h4>{title}</h4>
            </>
          }
          key="1"
        >
          {litemode ? (
            <>
              <div className="d-flex align-content-md-start flex-wrap w-100">
                <div className="col col-12">
                  <div className="row">
                    <span className="col-12 col-sm-2 col-md-12 content-label">{`Team`}</span>
                    <span className="col-12 col-sm-10 col-md-12 content-text">
                      {TeamName && TeamName.length > 0
                        ? TeamName[0].team_group_name
                        : `ไม่พบข้อมูล`}
                    </span>
                  </div>
                  <div className="row">
                    <span className="col-4 col-sm-2 col-md-12 content-label">{`Total Time`}</span>
                    <span className="col-8 col-sm-10 col-md-12 content-text">
                      {result_total_time && result_total_time.length > 0
                        ? `${result_total_time[0].days} days ${result_total_time[0].hours} hours ${result_total_time[0].min} mins`
                        : null}
                    </span>
                  </div>
                  <div className="row mt-3">
                    <div className="card w-100">
                      <div className="card-body">
                        {result_job_log.map((data, index) => (
                          <div
                            className="row no-gutters align-items-center mb-3"
                            style={{ lineHeight: 1 }}
                            key={`progress_detail_${index + 1}`}
                          >
                            <span className="col-12 col-sm-8 col-md-12 col-xl-8">
                              {data.process_name}
                            </span>
                            <span
                              className={`"col-12 col-sm-4 col-md-12 col-xl-4 content-text ${
                                isMobile ? "text-left" : "text-center"
                              }"`}
                            >
                              <FormatDateTime
                                text={data.creatE_DATE}
                              ></FormatDateTime>
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="d-flex align-content-md-start flex-wrap w-100">
                <div className="col col-12">
                  <div className="row">
                    <span className="col-12 col-sm-2 content-label">{`Team`}</span>
                    <span className="col-12 col-sm-10 content-text">
                      {TeamName && TeamName.length > 0
                        ? TeamName[0].emp_company_name
                        : `ไม่พบข้อมูล`}
                    </span>
                  </div>
                  <div className="row">
                    <span className="col-4 col-sm-2 content-label">{`Total Time`}</span>
                    <span className="col-8 col-sm-10 content-text">
                      {result_total_time && result_total_time.length > 0
                        ? `${result_total_time[0].days} days ${result_total_time[0].hours} hours ${result_total_time[0].min} mins`
                        : null}
                    </span>
                  </div>
                  <div className="row mt-3">
                    <Table
                      className="w-100"
                      columns={columns}
                      dataSource={result_job_log}
                      pagination={false}
                      tableLayout={"fixed"}
                      scroll={{ x: 700 }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </Panel>
      </Collapse>
    </>
  );
}
